module.exports = __webpack_public_path__ + "img/3_1.47ff8e0d.jpg";